import ProductListSwiper from "./swipers/productListSwiper";
import StoriesSwiper from "./swipers/storiesSwiper";

var swiperStories;
var storiesProductListSwipers = {};

$(() => {
    $('.story-products span').on('click', (e) => {
        showProductsPopup(e.target.dataset.story_id);
    });

    function getOpenedProductsPopup() {
        return $('.pp-story-products.show');
    }

    function showProductsPopup(id) {
        const popup = $(`.pp-story-products[data-story_id="${id}"]`);
        if (getOpenedProductsPopup().length)
            return;

        // Свайпер для продуктов в сториз
        if (!storiesProductListSwipers[id])
            storiesProductListSwipers[id] = new ProductListSwiper(
                `.pp.pp-story-products[data-story_id='${id}'] .products-swiper.swiper-container`,
                2.75,
                10,
                {
                    1921: {
                        slidesPerView: 6,
                        spaceBetween: 15,
                    },
                    1441: {
                        slidesPerView: 5,
                        spaceBetween: 16,
                    },
                    1281: {
                        slidesPerView: 4,
                        spaceBetween: 19,
                    },
                    1025: {
                        slidesPerView: 4,
                        spaceBetween: 19,
                    },
                    769: {
                        slidesPerView: 3.5,
                        spaceBetween: 14,
                    },
                    376: {
                        slidesPerView: 2.75,
                        spaceBetween: 10,
                    },
                }
            );

        swiperStories.pause();
        popup.addClass('show');
    }

    function closeProductsPopup() {
        const popup = getOpenedProductsPopup();
        if (!popup.length)
            return;
        popup.removeClass("show");

        swiperStories.resume();
    }

    function showPopup(data_pp) {
        $("html,body").addClass("noscroll");
        $(".pp").removeClass("show");
        $('.pp[data-pp="' + data_pp + '"]').addClass("show");
        $('.pp[data-pp="' + data_pp + '"]').trigger("click");
    }

    function ppClose(e = null) {
        if (e && $(e.target).closest('.pp-story-products').length) {
            closeProductsPopup();
            return;
        }
        if (swiperStories) {
            swiperStories.enabled = false;
            swiperStories.pause();
        }

        document
            .querySelectorAll("video.story-content-pp")
            .forEach(function (item) {
                item.pause();
                item.currentTime = 0;
            });

        $(".pp").removeClass("show");

        if (e && e.currentTarget.classList.contains("decrement__close") && !window.location.pathname.split('/').includes("order")) {
            $(".pp-cart").addClass("show");
        } else {
            $("html,body").removeClass("noscroll");
        }
    }

    $(document).on("click", ".pp_", function (e) {
        if (e.cancelable) e.preventDefault();
        var el = $(this);
        var th_pp = el.attr("data-pp");
        if (th_pp === "stories") {
            if (swiperStories === undefined) {
                swiperStories = new StoriesSwiper(".swiper-container_stories", el.index());

                let touchStartPos;
                document.addEventListener('touchstart', (e) => {
                    if (!swiperStories.enabled)
                        return;
                    touchStartPos = [e.touches[0].clientX, e.touches[0].clientY];
                });

                const yThreshold = 125; // Сколько нужно просвайпать по высоте, чтобы попап скрылся
                const xThreshold = 70; // Максимальное отклонение свайпа по ширине
                document.addEventListener('touchmove', (e) => {
                    if (!swiperStories.enabled || !touchStartPos)
                        return;
                    const xDiff = touchStartPos[0] - e.touches[0].clientX;
                    const yDiff = touchStartPos[1] - e.touches[0].clientY;
                    if (Math.abs(xDiff) < Math.abs(yDiff) && Math.abs(yDiff) > yThreshold && Math.abs(xDiff) < xThreshold)
                        ppClose();
                });
            } else {
                swiperStories.enabled = true;
                swiperStories.resume(el.index());
            }
        }

        showPopup(th_pp);
    });

    // Вызов закрытия попапа
    $(document).on(
        "click",
        ".pp__close, .pp__bg, .close_btn, .pp__success-btn, .pp__close-mob",
        function (e) {
            ppClose(e);
        }
    );

    // ???
    $(document).on("click", ".menu-bg.show", function () {
        $(".nav-wrapper").removeClass("show");
        $(".nav-wrapper-bg").removeClass("show-bg");
        $(".menu-bg").removeClass("show");
        $(".menu-logo-bg").removeClass("show");
        $(".pp__bg").removeClass("show");
        $("html,body").removeClass("noscroll");
    });

    // Вызов закрытия попапа при нажатии на Esc
    document.onkeydown = function (evt) {
        evt = evt || window.event;
        if (evt.keyCode === 27) {
            ppClose();
        }
    };
});
